export default "/_next/static/chunks/fonts/lato-100-italic-0aed5cc087e922e1618413bb5a9e1fa4.woff2";